import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useRpcClient } from '../../client/useRpcClient';
function useCacheSnapshot(key, cache) {
  return useSyncExternalStore(onStoreChange => cache.subscribe(key, onStoreChange), () => cache.read(key), () => cache.read(key));
}
const idleState = {
  loading: false,
  data: undefined,
  error: undefined
};
const loadingState = {
  loading: true,
  data: undefined,
  error: undefined
};
export const useAccessCache = (key, cache, options = {
  skip: false
}) => {
  const snapshot = useCacheSnapshot(key, cache);
  const httpClient = useHttpClient();
  const rpcClient = useRpcClient();
  useEffect(() => {
    if (options.skip) {
      return;
    }
    if (snapshot === undefined) {
      void cache.get(key, httpClient, rpcClient)
      // error is stored in the entry, but also thrown-
      // we should not let it bubble up here.
      // TODO: make sure we are correctly logging the error
      // like we do on master.
      .catch(() => {});
    }
  }, [snapshot, options.skip, httpClient, rpcClient, key, cache]);
  return useMemo(() => {
    if (options.skip) {
      return idleState;
    }
    if ((snapshot === null || snapshot === void 0 ? void 0 : snapshot.result.status) === 'success') {
      return {
        loading: false,
        data: snapshot.result.value,
        error: undefined
      };
    } else if ((snapshot === null || snapshot === void 0 ? void 0 : snapshot.result.status) === 'error') {
      return {
        loading: false,
        data: undefined,
        error: snapshot.result.error
      };
    } else {
      return loadingState;
    }
  }, [options.skip, snapshot]);
};